import { createVueCustomPage } from './createVueCustomPage';
import { loadScripts } from '@root/common/utils/scriptLoader';

interface CreateVueCustomPage extends Window {
  createVueCustomPage(): void;
}

declare const window: CreateVueCustomPage;

export async function renderCustomPage(data: { url: string; useLocalProject: boolean }): Promise<any> {
  if (!data.useLocalProject && data.url) {
    // Load custom page from url (used in production)
    await loadScripts(data.url);
    return window.createVueCustomPage();
  } else {
    // Create custom page component (used for dev and for build)
    return createVueCustomPage();
  }
}
